import {Component, Input, OnInit} from '@angular/core';
import moment from 'moment';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'bst-timeframe-display',
    templateUrl: './timeframe-display.component.html',
    styleUrls: ['./timeframe-display.component.scss'],
    standalone: false
})
export class TimeframeDisplayComponent implements OnInit {

  @Input() start: Date = null;
  @Input() end: Date = null;
  @Input() timeframe: [Date, Date] = null;
  @Input() markers: {date: Date, label:string}[] = null;

  private _width: number = 0;
  private _left: number = 0;
  private _markers: number[] = [];

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
    if(this.isvalid()){
      this._left = TimeframeDisplayComponent.calcPoint(this.start, this.timeframe);
      if(this.end){
        const r = TimeframeDisplayComponent.calcPoint(this.end, this.timeframe);
        if(r >= this._left){
          this._width = r - this._left;
        }
      }
      else{
        this._width = 1.0 - this._left;
      }

      if(this.markers){
        this._markers = this.markers.filter((o) => o).map((o) => {
          return TimeframeDisplayComponent.calcPoint(o.date, this.timeframe);
        });
      }
    }
  }

  public isvalid(){
    return this.timeframe
      && this.timeframe[0]
      && moment(this.timeframe[0]).isValid()
      && this.start
      && moment(this.start).isValid();
  }

  public get width(){
    return this._width > 1 ? this._width - this._left : this._width;
  }

  public get left(){
    return this._left;
  }

  public get marks(){
    return this._markers;
  }

  public static calcPoint(from: Date, timeframe: [Date, Date]){
    const timediff = moment(timeframe[1] || undefined).diff(moment(timeframe[0]), 'day');
    if(timediff > 0) {
      const daysdiff = moment(from).diff(moment(timeframe[0]), "day");
      return daysdiff / timediff;
    }
    return 0;
  }

}
